module.exports = __webpack_public_path__ + "static/media/undraw_friends_online_klj6.776cf934.svg";